import ControlsPlus from "@casino/external/icons/ControlsPlus";
import Button from "@casino/legacyUi/Button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@workspace/frontend-ui";
import OtherButtonsContainer from "./OtherButtonsContainer";

const ToggleButton: FC = ({ children }) => (
  <div className="relative" data-testid="social-register-toggle">
    <Popover>
      <PopoverTrigger asChild>
        <Button
          className="w-10 border border-border bg-secondary"
          iconLeft={
            <ControlsPlus className="relative left-1 text-xl/8 text-foreground" />
          }
        />
      </PopoverTrigger>
      <PopoverContent side="bottom" align="end" className="w-72 p-0">
        <OtherButtonsContainer>{children}</OtherButtonsContainer>
      </PopoverContent>
    </Popover>
  </div>
);

export default ToggleButton;
